import { z } from 'zod';

export const posTerminalSchema = z.object({
  /** Most useful in non-production env, e.g. `au.com.orderhub.pos.sta.v3` */
  appBundleId: z.string().nullable().default(null),
  appInstalledAt: z.number().nullable().default(null),
  /** e.g. "44" */
  appJsBuildVersion: z.string().nullable().default(null),
  /** e.g. "2.0.0" */
  appNativeBuildVersion: z.string().nullable().default(null),
  /** The unique identifier of the printer, e.g. "2550618081103643" */
  attachedUsbPrinterIdentifier: z.string().nullable().default(null),
  /**
   * iOS will change the vendor identifier (`idForVendor`) if all apps from the current app's vendor (OrderHub)
   * have been uninstalled. See https://docs.expo.dev/versions/latest/sdk/application/#applicationgetiosidforvendorasync
   * */
  idForVendor: z.string(),
  /** "15.7.1" */
  iosVersion: z.string().nullable().default(null),
  lanIp: z.string().nullable().default(null),
  /** e.g. "iPad (6th generation)" */
  modelName: z.string().nullable().default(null),
  /** e.g. "2018" */
  modelYear: z.string().nullable().default(null),
  /**
   * A custom name assigned to the device by the restaurant owner. e.g. "Front counter".
   * Note, this is not `iosDeviceName` which always shows as 'iPad' since iOS 16.
   * https://developer.apple.com/documentation/bundleresources/entitlements/com_apple_developer_device-information_user-assigned-device-name
   * */
  name: z.string().nullable().default(null),
  /** `uuid` is required in addition to `idForVendor` as restaurant owner may uninstall and install the app, thereby creating another
   * `idForVendor`. They can be prompted to replace the existing terminal with the new one (which persists the uuid) */
  uuid: z.string(),

  createdAt: z.number().optional(),
  updatedAt: z.number().optional(),
});
export type PosTerminal = z.output<typeof posTerminalSchema>;

export const posTerminalStrictSchema = posTerminalSchema.safeExtend({
  uuid: z.guid(),
});

export const posTerminalCvxSchema = posTerminalSchema.safeExtend({
  createdAt: z.number(),
  updatedAt: z.number(),
});
export type PosTerminalCvx = z.output<typeof posTerminalCvxSchema>;
